var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"specs",class:{ disabled: _vm.disabled }},[_c('MultipleSpecs',_vm._b({on:{"change":_vm.onMultipleSpecsChange}},'MultipleSpecs',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }